<template>
  <div class="app-container" style="background: #f4f5f7;">
    <div class="index-top flex flex-spacebetween">
      <div class="index-left">
        <BjDivider style="padding:10px 0;margin: 0;">{{ $t('homePage.Todolist') }}</BjDivider>
        <div class="flex">
          <div class="width25">
            <div class="index-title textaligncenter">{{ $t('route.BusinessInbound') }}</div>
            <div class="flex-align flex-spacebetween">
              <span>{{ $t('route.BusinessPurchaseOrderCsgAdminIndex')}}</span>
              <span class="te" @click="gotoPage('BusinessPurchaseOrderCsgAdminIndex')">{{ dataInfo2.openReceiptNum || 0 }}</span>
            </div>
          </div>
          <div class="width25" style="border-left: 2px dashed #f5f5f5">
            <div class="index-title textaligncenter">{{ $t('route.BusinessStockDelivery') }}</div>
            <div class="flex-align flex-spacebetween">
              <span>{{ $t('homePage.New') }}</span>
              <span class="te" @click="gotoPage('BusinessAbnormalOrderSTOCK')">{{ dataInfo2.newOrderNum || 0 }}</span>
            </div>
            <div class="flex-align flex-spacebetween">
              <span>{{ $t('homePage.Processing') }}</span>
              <span class="te" @click="gotoPage('BusinessAbnormalOrderPROCESSINGOrder')">{{ dataInfo2.pendingOrderNum || 0 }}</span>
            </div>
            <div class="flex-align flex-spacebetween">
              <span>{{ $t('homePage.Error') }}</span>
              <span class="te" @click="gotoPage('BusinessAbnormalOrderANOMALY')">{{ dataInfo2.exceptionOrderNum || 0 }}</span>
            </div>
            <div class="flex-align flex-spacebetween">
              <span>{{ $t('route.BusinessOrderShort')}}</span>
              <span class="te" @click="gotoPage('BusinessAbnormalOrderOUTOFSTOCK')">{{ dataInfo2.outOfStockOrderNum || 0 }}</span>
            </div>
            <div class="flex-align flex-spacebetween">
              <span>{{ $t('route.BusinessAbnormalOrderWAIRING')}}</span>
              <span class="te" @click="gotoPage('BusinessAbnormalOrderWAIRING')">{{ dataInfo2.collectPendingOrderNum || 0 }}</span>
            </div>
            <div class="flex-align flex-spacebetween">
              <span>{{ $t('route.BusinessAbnormalOrderCOLLECTPENDING')}}</span>
              <span class="te" @click="gotoPage('BusinessAbnormalOrderCOLLECTPENDING')">{{ dataInfo2.waitingOrderNum || 0 }}</span>
            </div>
            <div class="flex-align flex-spacebetween" v-if="!$store.getters.cusId">
              <span>{{ $t('route.BusinessAbnormalOrderUrgent') }}</span>
              <span class="te" @click="gotoPage('BusinessAbnormalOrderUrgent')">{{ dataInfo2.urgentOrderNum || 0 }}</span>
            </div>
          </div>
          <div class="width25" style="border-left: 2px dashed #f5f5f5">
            <div class="index-title textaligncenter">{{ $t('route.BusinessAfter') }}</div>
            <div class="flex-align flex-spacebetween">
              <span>{{ $t('homePage.InProcess') }}</span>
              <span class="te" @click="gotoPage('BusinessOpenReturnList')">{{ dataInfo2.waitingReturnOrderNum || 0 }}</span>
            </div>
          </div>
          <div class="width25" style="border-left: 2px dashed #f5f5f5">
            <div class="index-title textaligncenter">{{ $t('route.BusinessWorkorder') }}</div>
            <div class="flex-align flex-spacebetween" v-if="$store.getters.cusId">
              <span>{{ $t('homePage.Draft') }}</span>
              <span class="te" @click="gotoPage('BusinessOpenWorkorderList', { tabIndex: 1 })">{{ dataInfo2.draftTicketNum || 0 }}</span>
            </div>
            <div class="flex-align flex-spacebetween">
              <span>{{ $t('homePage.ApprovalPending') }}</span>
              <span class="te" @click="gotoPage('BusinessOpenWorkorderList', { tabIndex: 2 })">{{ dataInfo2.auditTicketNum || 0 }}</span>
            </div>
            <div class="flex-align flex-spacebetween">
              <span>{{ $t('homePage.AwaitingProcessing') }}</span>
              <span class="te" @click="gotoPage('BusinessOpenWorkorderList', { tabIndex: 3 })">{{ dataInfo2.waitProcessTicketNum || 0 }}</span>
            </div>
            <div class="flex-align flex-spacebetween">
              <span>{{ $t('homePage.InProgress') }}</span>
              <span class="te" @click="gotoPage('BusinessOpenWorkorderList', { tabIndex: 4 })">{{ dataInfo2.pendingTicketNum || 0 }}</span>
            </div>
            <div class="flex-align flex-spacebetween">
              <span>{{ $t('homePage.ApprovalRejected') }}</span>
              <span class="te" @click="gotoPage('BusinessOpenWorkorderList', { tabIndex: 6 })">{{ dataInfo2.failTicketNum || 0 }}</span>
            </div>
            <div class="flex-align flex-spacebetween" v-if="!$store.getters.cusId">
              <span>{{ $t('workOrderList.Confirm') }}</span>
              <span class="te" @click="gotoPage('BusinessOpenWorkorderList', { tabIndex: 9 })">{{ dataInfo2.confirmedTicketNum || 0 }}</span>
            </div>
          </div>
        </div>
        
      </div>
      <div class="index-right">
        <BjDivider style="padding:10px 0;margin: 0;">{{ $t('homePage.QuickAccess') }}</BjDivider>
        <div class="flex-align flex-spacebetween" style="margin:10px 0 5px;">
          <div style="font-size: 26px;">{{ $store.getters.userInfo.loginName }}</div>
          <div style="font-size:12px;line-height: 20px;" v-if="$store.getters.cusId">
            <div>{{ $t('homePage.SalesManager')}}：{{ $store.getters.userInfo.csgSales}}</div>
            <div>{{ $t('homePage.CustomerService') }}：{{ $store.getters.userInfo.csgCustomer}}</div>
          </div>
        </div>
        <div class="flex-align flex-wrap flex-spacebetween">
          <div class="flex-align flex flex-column index-right-bg" @click="gotoPage('BusinessPurchaseOrderCsgAdd')" v-if="$store.getters.cusId">
            <img src="@/assets/img/home1.png" class="index-right-img" />
            <span class="index-right-text">{{ $t('homePage.AddInbound') }}</span>
          </div>
          <div class="flex-align flex flex-column index-right-bg" @click="gotoPage('BusinessPurchaseOrderCsgAdminIndex')" v-if="!$store.getters.cusId">
            <img src="@/assets/img/home1.png" class="index-right-img" />
            <span class="index-right-text">{{ $t('homePage.Inbound') }}</span>
          </div>
          <div class="flex-align flex-column index-right-bg" @click="gotoPage('CSGGoodsSkuOrdinaryAdd')" v-if="$store.getters.cusId">
            <img src="@/assets/img/home2.png" class="index-right-img" />
            <span class="index-right-text">{{ $t('homePage.AddProduct') }}</span>
          </div>
          <div class="flex-align flex-column index-right-bg" @click="gotoPage('CSGGoodsSkuOrdinaryIndex')" v-if="!$store.getters.cusId">
            <img src="@/assets/img/home2.png" class="index-right-img" />
            <span class="index-right-text">{{ $t('homePage.Product') }}</span>
          </div>
          <div class="flex-align flex-column index-right-bg" @click="gotoPage('BusinessStockSearchCSG')">
            <img src="@/assets/img/home3.png" class="index-right-img" />
            <span class="index-right-text">{{ $t('homePage.Inventory') }}</span>
          </div>
          <div class="flex-align flex-column index-right-bg" @click="gotoPage('BusinessAddThirdOrderCSGView')" v-if="$store.getters.cusId">
            <img src="@/assets/img/home4.png" class="index-right-img" />
            <span class="index-right-text">{{ $t('homePage.AddOutbound') }}</span>
          </div>
          <div class="flex-align flex-column index-right-bg" @click="gotoPage('BusinessAbnormalOrderSTOCK')" v-if="!$store.getters.cusId">
            <img src="@/assets/img/home4.png" class="index-right-img" />
            <span class="index-right-text">{{ $t('homePage.Outbound') }}</span>
          </div>
          <div class="flex-align flex-column index-right-bg" @click="gotoPage('BusinessAfterReturnAdd')">
            <img src="@/assets/img/home5.png" class="index-right-img" />
            <span class="index-right-text">{{ $t('homePage.AddReturn') }}</span>
          </div>
          <div class="flex-align flex-column index-right-bg" @click="gotoPage('BusinessWorkorderListForm', {type: 'add'})">
            <img src="@/assets/img/home6.png" class="index-right-img" />
            <span class="index-right-text">{{ $t('homePage.AddTicket') }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <div class="index-top flex flex-spacebetween">
      <div class="index-bottom">
        <div class="index-left" style="width:100%; margin-top:20px;padding-bottom:40px;">
          <BjDivider style="padding:10px 0;margin: 0;">{{ $t('homePage.KeyData') }}</BjDivider>
          <div class="flex">
            <div class="width16">
              <div class="index-title">{{ $t('homePage.Date') }}</div>
              <div>{{ $t('homePage.Yesterday') }}</div>
              <div>{{ $t('homePage.Last7Days') }}</div>
              <div>{{ $t('homePage.Last30Days') }}</div>
            </div>
            <div class="width16 textalignright">
              <div class="index-title">{{ $t('homePage.TotalOutbound') }}</div>
              <div>{{ dataInfo.yesterdayCountAllOrder || 0 }}</div>
              <div>{{ dataInfo.last7DaysCountAllOrder || 0 }}</div>
              <div>{{ dataInfo.last30DaysCountAllOrder || 0 }}</div>
            </div>
            <div class="width16 textalignright">
              <div class="index-title">{{ $t('homePage.ShippedOutbound') }}</div>
              <div>{{ dataInfo.yesterdayCountCompleteOrder || 0 }}</div>
              <div>{{ dataInfo.last7DaysCountCompleteOrder || 0 }}</div>
              <div>{{ dataInfo.last30DaysCountCompleteOrder || 0 }}</div>
            </div>
            <div class="width16 textalignright">
              <div class="index-title">{{ $t('homePage.TotalInbound') }}</div>
              <div>{{ dataInfo.yesterdayCountAllInbound || 0 }}</div>
              <div>{{ dataInfo.last7DaysCountAllInbound || 0 }}</div>
              <div>{{ dataInfo.last30DaysCountAllInbound || 0 }}</div>
            </div>
            <div class="width16 textalignright">
              <div class="index-title">{{ $t('homePage.ShippedInbound') }}</div>
              <div>{{ dataInfo.yesterdayCountDoneInbound || 0 }}</div>
              <div>{{ dataInfo.last7DaysCountDoneInbound || 0 }}</div>
              <div>{{ dataInfo.last30DaysCountDoneInbound || 0 }}</div>
            </div>
            <div class="width16 textalignright">
              <div class="index-title">{{ $t('homePage.TotalReturn') }}</div>
              <div>{{ dataInfo.yesterdayCountAllReturn || 0 }}</div>
              <div>{{ dataInfo.last7DaysCountAllReturn || 0 }}</div>
              <div>{{ dataInfo.last30DaysCountAllReturn || 0 }}</div>
            </div>
          </div>
        </div>
        <div class="index-left" style="width:100%; margin-top:20px;padding-bottom:40px;">
          <BjDivider style="padding:10px 0;margin: 0;">{{ $t('homePage.BasicStatistic') }}</BjDivider>
          <div class="flex" v-if="!$store.getters.cusId">
            <div class="width16 flex-align" style="margin-top: 25px;">
              <img src="@/assets/img/home_bt0.png" class="index-left-img" />
              <div>
                <div class="index-bottom-text">{{ dataInfo2.customerNum || 0 }}</div>
                <div>{{ $t('homePage.TotalCustomers') }}</div>
              </div>
            </div>
            <div class="width16 flex-align" style="margin-top: 25px;">
              <img src="@/assets/img/home_bt1.png" class="index-left-img" />
              <div>
                <div class="index-bottom-text">{{ dataInfo2.completeOrderNum || 0 }}</div>
                <div>{{ $t('homePage.OrdersShipped') }}</div>
              </div>
            </div>
            <div class="width16 flex-align" style="margin-top: 25px;">
              <img src="@/assets/img/home_bt2.png" class="index-left-img" />
              <div>
                <div class="index-bottom-text">{{ dataInfo2.availableSkuNum || 0 }}</div>
                <div>{{ $t('homePage.AvailableSKU') }}</div>
              </div>
            </div>
            <div class="width16 flex-align" style="margin-top: 25px;">
              <img src="@/assets/img/home_bt3.png" class="index-left-img" />
              <div>
                <div class="index-bottom-text">{{ dataInfo2.availableInvNum || 0 }}</div>
                <div>{{ $t('homePage.AvailableInventory') }}</div>
              </div>
            </div>
            <div class="width16 flex-align" style="margin-top: 25px;">
              <img src="@/assets/img/home_bt4.png" class="index-left-img" />
              <div>
                <div class="index-bottom-text">{{ dataInfo2.availableShop || 0 }}</div>
                <div>{{ $t('homePage.AuthorizedStore') }}</div>
              </div>
            </div>
            <div class="width16 flex-align" style="margin-top: 25px;">
              <img src="@/assets/img/home_bt5.png" class="index-left-img" />
              <div>
                <div class="index-bottom-text">{{ dataInfo2.processedReturnOrderNum || 0 }}</div>
                <div>{{ $t('homePage.ProcessedReturn') }}</div>
              </div>
            </div>
          </div>
          <div class="flex" v-else>
            <div class="width20 flex-align">
              <img src="@/assets/img/home_bt1.png" class="index-left-img" />
              <div>
                <div class="index-bottom-text">{{ dataInfo2.completeOrderNum || 0 }}</div>
                <div>{{ $t('homePage.OrdersShipped') }}</div>
              </div>
            </div>
            <div class="width20 flex-align">
              <img src="@/assets/img/home_bt2.png" class="index-left-img" />
              <div>
                <div class="index-bottom-text">{{ dataInfo2.availableSkuNum || 0 }}</div>
                <div>{{ $t('homePage.AvailableSKU') }}</div>
              </div>
            </div>
            <div class="width20 flex-align">
              <img src="@/assets/img/home_bt3.png" class="index-left-img" />
              <div>
                <div class="index-bottom-text">{{ dataInfo2.availableInvNum || 0 }}</div>
                <div>{{ $t('homePage.AvailableInventory') }}</div>
              </div>
            </div>
            <div class="width20 flex-align">
              <img src="@/assets/img/home_bt4.png" class="index-left-img" />
              <div>
                <div class="index-bottom-text">{{ dataInfo2.availableShop || 0 }}</div>
                <div>{{ $t('homePage.AuthorizedStore') }}</div>
              </div>
            </div>
            <div class="width20 flex-align">
              <img src="@/assets/img/home_bt5.png" class="index-left-img" />
              <div>
                <div class="index-bottom-text">{{ dataInfo2.processedReturnOrderNum || 0 }}</div>
                <div>{{ $t('homePage.ProcessedReturn') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="index-right" style="margin-top:20px;font-size:10px;line-height: 18px;">
        <BjDivider style="padding:10px 0;margin: 6px;">{{ $t('homePage.OutboundOrder') }}</BjDivider>
        <el-tabs :value="tabStatus" type="card" @tab-click="handleTabClick">
          <el-tab-pane v-for="(item, index) in CSG_ORDER_LIST" :key="index" :label="$t(item.label)" :name="item.value" />
        </el-tabs>
        <div v-if="tabStatus == 1">
          <div v-for="(item,index) in dataList" :key="index" class="flex-spacebetween">
            <div class="ellipsis" style="width:100px;cursor: pointer;" @click="gotoOrderDetail(item)">
              <span style="width:22px;display:inline-block;">{{ index + 1 }}</span>
              <span>{{ item.webReference }}</span> 
              <span style="margin-left:2px;">{{ $t(LANG_ZH_EN_PS_LIST.bjGet(item.failureReason)) }}</span>
            </div>
            <span class="ellipsis" style="width:140px;" v-if="!$store.getters.cusId">{{ customerList.bjGet(item.cusId) }}</span>
            <span>{{ item.creationDate | timeFilters({isSession:true, dateFormat:'DD/MM/YYYY'}) }}</span>
          </div>
        </div>
        <div v-if="tabStatus == 2">
          <div v-for="(item,index) in dataList" :key="index" class="flex-spacebetween">
            <div class="ellipsis" style="width:170px;cursor: pointer;" @click="gotoOrderDetail(item)">
              <span style="width:22px;display:inline-block;">{{ index + 1 }}</span>
              <span>{{ item.outerOrderNo }}</span>
            </div>
          </div>
          <span>{{ item.creationDate | timeFilters({isSession:true, dateFormat:'DD/MM/YYYY'}) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { orderApi, afterApi } from '@/api';
import { LANG_ZH_EN_PS_LIST } from '@/utils/constants';

export default {
  name: 'Dashboard',
  data() {
    return {
      CSG_ORDER_LIST: [
        {label: 'route.BusinessAbnormalOrderANOMALY', value: 1},
        {label: 'route.BusinessAbnormalOrderOUTOFSTOCK', value: 2},
      ],
      tabStatus: 1,
      dataList: [],
      LANG_ZH_EN_PS_LIST,
      dataInfo: {},
      dataInfo2: {
        openReceiptNum:'-',
        newOrderNum:'-',
        pendingOrderNum:'-',
        exceptionOrderNum:'-',
        outOfStockOrderNum:'-',
        collectPendingOrderNum:'-',
        waitingOrderNum:'-',
        urgentOrderNum:'-',
        waitingReturnOrderNum:'-',
        draftTicketNum:'-',
        auditTicketNum:'-',
        waitProcessTicketNum:'-',
        pendingTicketNum:'-',
        failTicketNum:'-',
        confirmedTicketNum:'-',
        customerNum:'-',
        completeOrderNum:'-',
        availableSkuNum:'-',
        availableInvNum:'-',
        availableShop:'-',
        processedReturnOrderNum:'-',
      },
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    customerList() {
      return this.$store.getters.customerList;
    },
  },
  mounted() {
    this._getDashboardKeyData()
    this._getThirdOrderPage()
    this._getDashboardMain()
    this.$nextTick(() => {
      if (window.location.hostname != '54.79.134.243' && this.userInfo.tenantName == 'SELLO') {
        this.$alert(this.$t('AccountManagementAdd.customerInfo.userTip'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          callback: async() => {
            await this.$store.dispatch('user/logout');
            sessionStorage.clear();
          }
        });
        return;
      }
      if (this.userInfo.lock) {
        this.$alert(
          `${this.$t('lockTip2')}
          </br>${this.$t('lockTip3')}
          </br>${this.$t('lockTip4')}
          </br>${this.$t('lockTip5')}
          </br>${this.$t('lockTip6')}
          `, this.$t('lockTip1'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('toast.okText'),
          callback: async() => {}
        });
      }
    });
  },
  methods:{
    gotoPage(name, val){
      if(val){
        this.$toPage(name, val);
      }else{
        this.$toPage(name);
      }
    },
    gotoOrderDetail(item){
      if(this.tabStatus == 1){
        this.$router.push({
          name: 'BusinessThirdOrderCSGView',
          query: { id: '', code: encodeURIComponent(item.outerOrderNo), status: item.totalOrderStatus, type: 'view' },
        });
      }else{
        this.$router.push({
          name: 'BusinessOrderInternalViewCSG',
          query: { id: '', code: encodeURIComponent(item.innerOrderNo), type: 'edit', status: 4 },
        });
      }
    },
    _getDashboardKeyData(){
      afterApi.getDashboardKeyData().then(res=>{
        this.dataInfo = res
      })
    },
    _getDashboardMain(){
      afterApi.getDashboardMain().then(res=>{
        this.dataInfo2 = res
      })
    },
    _getThirdOrderPage(){
      orderApi.getThirdOrderPage({
        circulationStatus: 1,
        operationType: 2,
        payStatus: "1",
        page: 0,
        size: 20,
      }).then(res=>{
        this.dataList = res.content;
      })
    },
    _getInternalStockoutPage(){
      orderApi.getInternalStockoutPage({
        cusId: this.$store.getters.cusId || null,
        page: 0,
        size: 20,
      }).then(res=>{
        this.dataList = res.content;
      })
    },
    handleTabClick(tab){
      if(tab.name == 2){
        this._getInternalStockoutPage()
      }else{
        this._getThirdOrderPage()
      }
    }
  },
  // destroyed() {
  //   sessionStorage.clear();
  // }
};
</script>
<style lang="scss" scoped>
.width25{
  width:25%;
  padding: 16px 30px;
}
.textaligncenter{
  text-align: center;
}
.textalignright{
  text-align: right;
}
.width20{
  width:20%;
  padding: 16px;
  margin-top: 25px;
}
.width16{
  width: 16.6%;
  padding: 16px;
  font-size: 13px;
}
.te{
  color: $main-dark;
  cursor: pointer;
}
.index-top{
  font-size: 15px;
  line-height: 28px;
}
.index-bottom{
  width: calc(100% - 370px);
  &-text{
    font-size: 18px;
    font-weight: bold;
  }
}
.index{
  &-title{
    font-weight: bold;
    margin-bottom: 10px;
  }
  &-left{
    width: calc(100% - 370px);
    padding: 0 20px;
    border: 1px solid #ddd;
    border-radius: 10px;
    background: #fff;
    &-img{
      width: 42px;
      height: 42px;
      margin-right: 20px;
    }
  }
  &-right{
    width: 350px;
    padding: 0 20px;
    border: 1px solid #ddd;
    border-radius: 10px;
    background: #fff;
    &-bg{
      width:80px;
      height:70px;
      background: #020079;
      border-radius: 10px;
      margin-top: 12px;
      color: #fff;
      font-size:10px;
      line-height: 16px;
      cursor: pointer;
    }
    &-img{
      width: 40px;
      height: 40px;
      margin-top: 5px;
    }
  }
}
</style>
